<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title flex_between">
      <span>
        <span>诊后管理费/诊金</span>
      </span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div class="box">
      <div class="container">
        <div class="infobox">
          <div class="info">
            <div>
              <span class="infotitle">用户昵称：</span>
              <span>{{ detail.nick_name }}</span>
            </div>
            <div style="margin: 14px 0">
              <span class="infotitle">性别：</span>
              <span>{{ detail.user_sex == 1 ? "男" : "女" }}</span>
            </div>
            <div>
              <span class="infotitle">手机号：</span>
              <span>{{ detail.user_phone }}</span>
            </div>
          </div>
          <div class="info" style="margin: 0 20px">
            <div>
              <span class="infotitle">患者姓名：</span>
              <span>{{ detail.user_name }}</span>
            </div>
            <div style="margin: 14px 0">
              <span class="infotitle">性别：</span>
              <span>{{ detail.patient_sex == 1 ? "男" : "女" }}</span>
            </div>
            <div>
              <span class="infotitle">年龄：</span>
              <span>{{ detail.age }}</span>
            </div>
          </div>
          <div class="info">
            <div>
              <span class="infotitle">医生姓名：</span>
              <span
                @click="showDocMsg(detail.doctor_id)"
                style="cursor: pointer"
                >{{ detail.doctor_name }}</span
              >
            </div>
            <div style="margin: 14px 0">
              <span class="infotitle">性别：</span>
              <span>{{ detail.doctor_sex == 1 ? "男" : "女" }}</span>
            </div>
            <div>
              <span class="infotitle">手机号：</span>
              <span>{{ detail.doctor_phone }}</span>
            </div>
          </div>
        </div>
        <div class="item">
          <div style="margin-bottom: 10px">
            <span>
              <span class="gray">交易单号：</span>
              <span>{{ detail.trade_no }}</span>
            </span>
            <span style="margin: 0 40px">
              <span class="gray">支付方式：</span>
              <span v-if="detail.pay_type == 1">微信支付</span>
              <span v-if="detail.pay_type == 2">支付宝支付</span>
            </span>
            <span>
              <span class="gray">支付来源：</span>
              <span v-if="detail.pay_from == 1">公众号</span>
              <span v-if="detail.pay_from == 2">患者App</span>
              <span v-if="detail.pay_from == 3">小程序</span>
            </span>
          </div>
          <div>
            <span class="gray">支付时间：</span>
            <span>{{ detail.pay_time }}</span>
            <span class="gray" style="margin-left: 100px">支付金额：</span>
            <span>{{ detail.pay_money }}</span>
          </div>
          <div style="margin-top: 10px" v-if="detail.settlement_status == 4">
            <span class="gray">退款时间：</span>
            <span>{{ detail.refund_time }}</span>
            <span class="gray" style="margin-left: 100px">退款金额：</span>
            <span>-{{ detail.refund_money }}</span>
          </div>
        </div>
        <div class="item">
          <div>
            <span class="gray">订单编号：</span>
            <span>{{ detail.order_sn }}</span>
            <span v-if="detail.status == 4">
              <span class="gray" style="margin-left: 100px">收货时间：</span>
              <span>{{ detail.completion_time }}</span>
            </span>
          </div>
          <div style="margin: 10px 0">
            <span class="gray">药房名称：</span>
            <span>{{ detail.hospital_name }}</span>
          </div>
          <div style="color: #f24e33">
            <span>
              <span>药品金额：</span>
              <span>{{ detail.drug_price }}</span>
            </span>
            <span style="margin-left: 100px">
              <span>诊后管理费：</span>
              <span>{{ detail.drug_profit }}</span>
              <!--  -->
              <span v-if="detail.group_doctor_id">
                ( 开方医生{{ detail.order_consult_drug_price }},
                工作室分成医生{{ detail.group_consult_drug_price }})
                <el-link type="primary" @click="openDetail"
                  >查看分成详情</el-link
                >
              </span>
            </span>
          </div>
          <div style="color: #f24e33; margin: 10px 0">
            <span>
              <span>诊金：</span>
              <span>{{ detail.consulting_gold }}</span>
            </span>
          </div>
          <div style="color: #f24e33">
            <span>优惠金额：</span>
            <span>- {{ detail.discount_price }}</span>
          </div>
          <div style="margin: 10px 0">
            <span class="gray">运费：</span>
            <span>{{ detail.freight_price }}</span>
          </div>
          <div style="margin: 10px 0">
            <span class="gray">优惠券金额：</span>
            <span>-{{ detail.coupon_money }}</span>
          </div>
          <div style="margin: 10px 0">
            <span class="gray">礼品卡金额：</span>
            <span>-{{ detail.gift_money }}</span>
          </div>
          <div>
            <span class="gray">订单金额：</span>
            <span>{{ detail.order_money }}</span>
          </div>
        </div>

        <div class="item">
          <div>
            <span class="gray">订单状态：</span>
            <span v-if="detail.status == 1">待审核</span>
            <span v-if="detail.status == 2">待发药</span>
            <span v-if="detail.status == 3">待收货</span>
            <span v-if="detail.status == 4">已完成</span>
            <span v-if="detail.status == 5">已取消</span>
            <span v-if="detail.status == 5">
              <span class="gray" style="margin-left: 100px">取消原因：</span>
              <span>{{ detail.reject_desc }}</span>
            </span>
          </div>
          <div style="margin-top: 10px">
            <span class="gray">结算状态：</span>
            <span v-if="detail.settlement_status == 1">待系统核算</span>
            <span v-if="detail.settlement_status == 2">待结算</span>
            <span v-if="detail.settlement_status == 3">已结算</span>
            <span v-if="detail.settlement_status == 4">已退款</span>
          </div>
          <div
            v-if="
              detail.settlement_status == 3 || detail.settlement_status == 2
            "
            style="margin-top: 10px"
          >
            <div>
              <span class="gray">预结算时间：</span>
              <span>{{ detail.psa_time }}</span>
            </div>
            <div style="margin-top: 10px">
              <span class="gray">结算帐期：</span>
              <span>{{ detail.period }}</span>
            </div>
            <div style="margin-top: 10px" v-if="detail.settlement_status == 3">
              <span class="gray">结算入账时间：</span>
              <span>{{ detail.sa_time }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import doctor_fee from "../../../api/doctor_fee";
import platform from "../../../api/platform";
import DocMsg from "../../../components/common/DocMsg.vue";
export default {
  data() {
    return {
      detail: {},
      order_id: this.$route.query.order_id,
      doc_msg: false,
      doctorId: "",
    };
  },
  components: {
    DocMsg,
  },
  methods: {
    back() {
      history.back();
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    getDetail() {
      let order_id = this.$route.query.order_id;
      doctor_fee.getOrderCostInfo({ order_id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data.info;
          this.detail.pay_time = platform.timestampToTime(this.detail.pay_time);

          this.detail.completion_time = this.detail.completion_time
            ? platform.timestampToTime(this.detail.completion_time)
            : "";
          this.detail.send_time = this.detail.send_time
            ? platform.timestampToTime(this.detail.send_time)
            : "";
          this.detail.refund_time = this.detail.refund_time
            ? platform.timestampToTime(this.detail.refund_time)
            : "";
          this.detail.psa_time = this.detail.psa_time
            ? platform.timestampToTime(this.detail.psa_time)
            : "";
          this.detail.period = this.detail.period
            ? platform.timestampToDate(this.detail.period).slice(0, 7)
            : "";
          this.detail.sa_time = this.detail.sa_time
            ? platform.timestampToTime(this.detail.sa_time)
            : "";
        }
      });
    },
    // 查看详情
    openDetail() {
      let {
        drug_profit,
        doctor_name,
        doctor_phone,
        order_proportion,
        order_consult_drug_price,
        group_doctor_name,
        group_doctor_phone,
        group_proportion,
        group_consult_drug_price,
      } = this.detail;
      let strHtml = `<div style="text-align: left;">
        <p style="line-height: 38px;">订单诊后管理费总金额：${drug_profit}</p>
        <p style="line-height: 38px;">开方医生：${doctor_name}(${doctor_phone})</p>
        <p style="line-height: 38px;">开方医生分成比例：${order_proportion}%</p>
        <p style="line-height: 38px;">开方医生诊后管理费：${order_consult_drug_price}</p>
        <p style="line-height: 38px;">工作室分成医生：${group_doctor_name}(${group_doctor_phone})</p>
        <p style="line-height: 38px;">工作室分成医生分成比例：${group_proportion}%</p>
        <p style="line-height: 38px;">工作室分成医生诊后管理费：${group_consult_drug_price}</p>
        </div>
      `;
      this.$alert(strHtml, "详情", {
        dangerouslyUseHTMLString: true,
      });
    },
  },
  created() {
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
.box {
  padding: 20px;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.infobox {
  display: flex;
  .info {
    background-color: #f9f8ee;
    border: solid 1px #dad8ca;
    padding: 14px 60px 14px 20px;
  }
}
.item {
  border: solid 1px #cfcece;
  padding: 20px;
  margin-top: 20px;
}
.gray {
  color: #747981;
}
.infotitle {
  display: inline-block;
  width: 75px;
}
</style>